import React from 'react';
import { Carousel } from 'react-bootstrap';

const images = [
  { src: 'https://via.placeholder.com/800x500', caption: 'First slide' },
  { src: 'https://via.placeholder.com/800x500', caption: 'Second slide' },
  { src: 'https://via.placeholder.com/800x500', caption: 'Third slide' }
];

const MyCarousel = () => {
  return (
    <Carousel>
      {images.map((image, index) => (
        <Carousel.Item key={index}>
          <img className="d-block w-100" src={image.src} alt={image.caption} />
          <Carousel.Caption>
            <h3>{image.caption}</h3>
          </Carousel.Caption>
        </Carousel.Item>
      ))}
    </Carousel>
  );
};

export default MyCarousel;
